import { GridItem } from '@xing-com/grid';

import { SKELETON_BODY_COUNT } from '../../constants';

import { Styled } from './article-list.skeleton.styles';

export const ArticleListSkeleton: React.FC = () => (
  <>
    <Styled.GlossaryGridContainer variant="FullSize">
      <GridItem span={8} spanMedium={5}>
        <Styled.GlossarySkeletonHeadline amountRows={1} size="small" />
      </GridItem>
      <GridItem span={12}>
        <Styled.GlossarySkeletonBody amountRows={2} />
      </GridItem>
    </Styled.GlossaryGridContainer>
    <Styled.GridContainer variant="FullSize">
      <GridItem spanMedium={1} span={2}>
        <Styled.SkeletonHeadline amountRows={1} size="large" />
      </GridItem>
      <GridItem span={12}>
        <Styled.Divider />
      </GridItem>
      {Array.from(Array(SKELETON_BODY_COUNT).keys()).map((id) => (
        <GridItem key={id} spanMedium={6} start={1} span={12}>
          <Styled.SkeletonBody />
        </GridItem>
      ))}
    </Styled.GridContainer>
  </>
);
